import luhn from './luhn';
import mod11And10 from './mod11And10';
import mod37And36 from './mod37And36';
export default {
    luhn,
    mod11And10,
    mod37And36,
};



// WEBPACK FOOTER //
// ./node_modules/formvalidation/dist/es6/algorithms/index.js